// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1dad1f47","455":"c8819372","977":"c96cb967"}[chunkId] + ".chunk.js";
};